import {
    ARTISAN_PRODUCT_CREATE_FAIL,
    ARTISAN_PRODUCT_CREATE_REQUEST,
    ARTISAN_PRODUCT_CREATE_SUCCESS,
    ARTISAN_PRODUCT_DELETE_FAIL,
    ARTISAN_PRODUCT_DELETE_REQUEST,
    ARTISAN_PRODUCT_DELETE_SUCCESS,
    ARTISAN_PRODUCT_DETAILS_FAIL,
    ARTISAN_PRODUCT_DETAILS_REQUEST,
    ARTISAN_PRODUCT_DETAILS_SUCCESS,
    ARTISAN_PRODUCT_LIST_FAIL,
    ARTISAN_PRODUCT_LIST_REQUEST, ARTISAN_PRODUCT_LIST_SUCCESS
} from '../constants/ArtisanConstants';
import { logout } from './AuthActions';
import axios from 'axios';
import { server_api } from './api';


export const artisanProductListAction = () => async (dispatch, getState) => {

    try {
        dispatch({
            type: ARTISAN_PRODUCT_LIST_REQUEST
        })

        const { authLogin: { info } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/artisan/products`, config)

        dispatch({
            type: ARTISAN_PRODUCT_LIST_SUCCESS,
            payload: data
        })


    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: ARTISAN_PRODUCT_LIST_FAIL,
            payload: resErr
        })
    }
}


export const artisanProductDetailsAction = (id) => async (dispatch, getState) => {

    try {

        dispatch({
            type: ARTISAN_PRODUCT_DETAILS_REQUEST
        })

        const { authLogin: { info } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        const { data } = await axios.get(`${server_api}/api/artisan/product/${id}`, config)

        dispatch({
            type: ARTISAN_PRODUCT_DETAILS_SUCCESS,
            payload: data
        })

    } catch (error) {

        const resErr = error.response && error.response.data.message ? error.response.data.message : error.message

        dispatch({
            type: ARTISAN_PRODUCT_DETAILS_FAIL,
            payload: resErr
        })
    }
}




export const artisanDeleteProduct = (id) => async (dispatch, getState) => {

    try {

        dispatch({
            type: ARTISAN_PRODUCT_DELETE_REQUEST
        })

        const { authLogin: { info } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }


        await axios.delete(`${server_api}/api/artisan/product/${id}`, config)

        dispatch({
            type: ARTISAN_PRODUCT_DELETE_SUCCESS
        })


    } catch (error) {
        const message = error.response && error.response.data.message
            ? error.response.data.message
            : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: ARTISAN_PRODUCT_DELETE_FAIL,
            payload: message,
        })
    }

}



export const artisanCreateProduct = (productData) => async (dispatch, getState) => {

    try {

        dispatch({
            type: ARTISAN_PRODUCT_CREATE_REQUEST,
        })

        const { authLogin: { info } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${info.token}`
            }
        }

        await axios.post(`${server_api}/api/artisan/product`, productData, config)

        dispatch({
            type: ARTISAN_PRODUCT_CREATE_SUCCESS,
        })

    } catch (error) {

        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message

        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }

        dispatch({
            type: ARTISAN_PRODUCT_CREATE_FAIL,
            payload: message,
        })
    }
}